import { container, title } from "assets/jss/material-kit-react.js";

const landingPageStyle = {
  container: {
    zIndex: "12",
    color: "#FFFFFF",
    ...container,
  },
  modalBackdrop: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 500,
  },
  parallaxContainer: {
    "@media (max-width: 768px)": {
      display: "none",
    },
  },
  staticImageContainer: {
    display: "none",
    "@media (max-width: 768px)": {
      display: "block",
    },
    "& figure": {
      width: "100%",
      margin: "0",
    },
    "& img": {
      width: "100%",
      maxHeight: "360px",
      objectFit: "cover",
    },
    "& figcaption": {
      marginTop: "4px",
      padding: "0 24px",
      color: "#ababab",
      textAlign: "right",
      fontSize: "14px",
    },
  },
  mobileHeroInfo: {
    zIndex: "12",
    color: "#FFFFFF",
    paddingInline: "24px",
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    color: "#FFFFFF",
    textDecoration: "none",
    fontSize: "34px",
    textAlign: "left",
    fontWeight: "400",
    "@media (min-width: 400px)": {
      fontSize: "40px",
    },
    "@media (min-width: 768px)": {
      fontSize: "64px",
    },
  },

  careText: {
    fontSize: "20px",
    textAlign: "left",
    "@media (min-width: 600px)": {
      fontSize: "24px",
    },
    "@media (min-width: 960px)": {
      fontSize: "32px",
    },
  },
  infoTitle: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    color: "#224B55",
    textDecoration: "none",
  },
  title_black: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    color: "#000000",
    textDecoration: "none",
  },
  subtitle: {
    fontSize: "1.313rem",
    maxWidth: "500px",
    margin: "10px auto 0",
  },
  main: {
    background: "#00000",
    position: "relative",
    zIndex: "3",
  },
  aboutSection: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3",
  },
  main_beduin: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3",
    backgroundImage: "url(" + require("assets/img/barn.jpg") + ")",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingBottom: "1em",
  },

  mainRaised: {
    margin: "-60px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
  },
  careAndShareButtons: {
    display: "flex",
    gap: "8px",
    alignItems: "flex-start",
    flexDirection: "row",
  },
  careButtonProgress: {
    marginLeft: "1em",
    color: "#ff6000",
  },
};

export default landingPageStyle;
